import { render } from "./NewsItem.vue?vue&type=template&id=450bb79a&scoped=true&ts=true"
import script from "./NewsItem.vue?vue&type=script&lang=ts"
export * from "./NewsItem.vue?vue&type=script&lang=ts"

import "./NewsItem.vue?vue&type=style&index=0&id=450bb79a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450bb79a"]])

export default __exports__